module.exports = __webpack_public_path__ + "static/media/Apple_Pay_logo.4b3641c9.svg";